import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

const GroupsProfile = ({userId, profileId}) => {
    return (
        <div className="profile-container">
            <h1> {userId} and {profileId} </h1>
        </div>
    );
};

export default GroupsProfile;